import Icon from '@Shared/Icon';
import { IOrg } from '@src/interfaces';
import React from 'react';
import { ListGroupItem } from 'react-bootstrap';

interface Props {
  node: IOrg,
  active: number | null | undefined,
  setter: (org_id: number) => void
}

const GetStartedOrg: React.FC<Props> = (props) => {
  return (
    <ListGroupItem
      active={props.active == props.node.id}
      style={{
        paddingLeft: 44, position: 'relative', overflow: 'hidden',
        paddingRight: '15px'
      }}
      action
      onClick={() => {
        props.setter(props.node.id);
      }}
    >
      <Icon name={'home'} className='list-icon' style={{
        position: 'absolute',
        left: 12,
        top: 16,
        fontSize: 20
      }} />
      {props.node.name}
    </ListGroupItem>
  );
}

export default GetStartedOrg;